module.exports = __webpack_public_path__ + "img/duplicate.9ac4bf3a.svg";